/** @format */

import { ChangeDetectionStrategy, Component, Signal, computed, inject, input } from '@angular/core';
import { CompareProductDetailsError, CompareProductItem } from '@compare/data-access';
import {
	HeaderStoreSelection,
	ProductAvailabilityCollection
} from '@shared/data-access/interfaces';

import { ProductAvailabilityComponent } from '@shared/components';
import { SkeletonFulfillmentSectionComponent } from '../skeleton-fulfillment-section/skeleton-fulfillment-section.component';
import { Store } from '@ngrx/store';
import { WINDOW } from '@shared/data-access/services';
import { selectUserStoreInfo } from '@state/data-access';

@Component({
	selector: 'compare-components-fulfillment-section',
	imports: [SkeletonFulfillmentSectionComponent, ProductAvailabilityComponent],
	templateUrl: './fulfillment-section.component.html',
	styleUrl: './fulfillment-section.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FulfillmentSectionComponent {
	private readonly store = inject(Store);

	readonly productEcode = input.required<string>();
	readonly productDetailsData = input.required<CompareProductItem | null>();
	readonly compareProductsAvailability = input.required<ProductAvailabilityCollection>();

	readonly userStoreInfo = this.store.selectSignal<HeaderStoreSelection>(selectUserStoreInfo);

	readonly isLoadingFulfillment = computed(() => !this.compareProductsAvailability());

	readonly isLoading = computed(() => !this.productDetailsData());

	readonly productErrors: Signal<CompareProductDetailsError[]> = computed(() =>
		this.checkForProductErrors(this.productDetailsData())
	);

	private readonly window = inject<Window>(WINDOW);

	openStoreDrawer(): void {
		if (this.window?.headerFunctions?.storeSelection) {
			this.window.headerFunctions.storeSelection();
		} else {
			console.warn(
				'Store selection function is not available in the current window context.'
			);
		}
	}

	private checkForProductErrors(
		productDetailsData: CompareProductItem | null
	): CompareProductDetailsError[] {
		if (!productDetailsData) {
			return [];
		}

		const errors = [];

		if (!productDetailsData.style) {
			errors.push('noStyle');
		}

		if (!productDetailsData.style?.prices) {
			errors.push('noPrices');
		}

		return errors;
	}
}
